import {
  TL_RECON_LOADING,
  TL_RECON_REPORT_LOADED,
  TL_RECON_REPORT_FAILED,
  TL_RECON_EXECUTING,
  TL_RECON_EXECUTED,
  TL_RECON_EXECUTE_FAILED,
  TL_RECON_ROW_UPDATING,
  TL_RECON_ROW_UPDATED,
  TL_RECON_ROW_UPDATE_FAILED,
  TL_RECON_ROW_APPROVED,
  TL_RECON_ROW_RESOLVED,
  TL_RECON_MAPPINGS_LOADED,
  TL_RECON_MAPPINGS_FAILED,
  TL_RECON_COMPANIES_LOADED,
  TL_RECON_COMPANIES_FAILED,
  TL_RECON_UNMAPPED_ORGS_LOADED,
  TL_RECON_UNMAPPED_ORGS_FAILED,
} from '../components/actions/threatlockerReconTypes'

const initialState = {
  loading: false,
  report: [],
  lastPushDate: null,
  executing: false,
  updatingRowId: null,
  orgMappings: [],
  companyLabels: [],
  unmappedOrgs: [],
}

const threatlockerReconReducer = (state = initialState, action) => {
  switch (action.type) {
    case TL_RECON_LOADING:
      state.loading = true
      return state
    case TL_RECON_REPORT_LOADED:
      state.loading = false
      state.report = action.payload.rows || []
      state.lastPushDate = action.payload.lastPushDate || null
      return state
    case TL_RECON_REPORT_FAILED:
      state.loading = false
      return state
    case TL_RECON_EXECUTING:
      state.executing = true
      return state
    case TL_RECON_EXECUTED:
      state.executing = false
      return state
    case TL_RECON_EXECUTE_FAILED:
      state.executing = false
      return state
    case TL_RECON_ROW_UPDATING:
      state.updatingRowId = action.payload
      return state
    case TL_RECON_ROW_UPDATED:
      state.updatingRowId = null
      return state
    case TL_RECON_ROW_UPDATE_FAILED:
      state.updatingRowId = null
      return state
    case TL_RECON_ROW_APPROVED:
      state.updatingRowId = null
      if (state.report) {
        state.report = state.report.map((r) =>
          r.companyId === action.payload
            ? { ...r, status: 'Approved', statusReason: null }
            : r
        )
      }
      return state
    case TL_RECON_ROW_RESOLVED:
      state.updatingRowId = null
      if (state.report) {
        state.report = state.report.map((r) =>
          r.companyId === action.payload
            ? { ...r, status: 'Pending', statusReason: null }
            : r
        )
      }
      return state
    case TL_RECON_MAPPINGS_LOADED:
      state.orgMappings = action.payload
      return state
    case TL_RECON_MAPPINGS_FAILED:
      return state
    case TL_RECON_COMPANIES_LOADED:
      state.companyLabels = action.payload
      return state
    case TL_RECON_COMPANIES_FAILED:
      return state
    case TL_RECON_UNMAPPED_ORGS_LOADED:
      state.unmappedOrgs = action.payload
      return state
    case TL_RECON_UNMAPPED_ORGS_FAILED:
      return state
    default:
      return state
  }
}

export default threatlockerReconReducer
